import exceptions from './exceptions'
const routes = [
  ...exceptions
]

export default routes
